import script from "./NhapXuatTonKhoPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapXuatTonKhoPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./NhapXuatTonKhoPrintModal.vue?vue&type=style&index=0&id=652b5526&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652b5526"]])

export default __exports__